import api from './api'
import http from 'axios'
export const getHeader = async () => {
  let headerUrl = api.common.header()
  let rets = ''
  try {
    rets = await http({
      method: 'get',
      url: headerUrl,
      data: {}
    })
  } catch (error) {
    console.log(error)
  }
  return rets
}
export const getFooter = async () => {
  let headerUrl = api.common.footer()
  let rets = ''
  try {
    rets = await http({
      method: 'get',
      url: headerUrl,
      data: {}
    })
  } catch (error) {
    console.log(error)
  }
  return rets
}

function getWeekFun (num) {
  let myDate1 = new Date()
  let ms = 24 * 3600 * 1000 * num
  let date = new Date(myDate1.getTime() + ms)
  // let y = date.getFullYear()
  // let m = '0' + (date.getMonth() + 1)
  // let d = '0' + (date.getDate())
  // let dayTime = `${y}-${m.substring(m.length - 2, m.length)}-${d.substring(d.length - 2, d.length)}`
  // console.log('d:', d)
  let weekday = new Array(7)
  weekday[0] = '周日'
  weekday[1] = '周一'
  weekday[2] = '周二'
  weekday[3] = '周三'
  weekday[4] = '周四'
  weekday[5] = '周五'
  weekday[6] = '周六'
  let week = weekday[date.getDay()]
  // console.log('Today it is ' + weekday[d.getDay()])
  // console.log('dayTime:', dayTime)
  return week
}
export const getDay = (num, str) => {
  let today = new Date()
  let nowTime = today.getTime()
  let ms = 24 * 3600 * 1000 * num
  today.setTime(parseInt(nowTime + ms))
  let oYear = today.getFullYear()
  let oMoth = (today.getMonth() + 1).toString()
  if (oMoth.length <= 1) oMoth = '0' + oMoth
  let oDay = today.getDate().toString()
  if (oDay.length <= 1) oDay = '0' + oDay
  return oYear + str + oMoth + str + oDay
}

export const sevenDays = (length) => {
  let dayList = []
  for (let i = 1; i < length; i++) {
    let year = getDay(i, '-')
    let week = getWeekFun(i)
    let item = {
      week,
      year
    }
    dayList.push(item)
  }
  return dayList
}

export const timeFilter = (time) => {
  let timeEnd1 = ''
  let timeEnd2 = ''
  let timeStr1 = time.substr(0, 2)
  let timeStr2 = time.substr(3, 2)
  if (timeStr2 === '00') {
    timeEnd1 = timeStr1
    timeEnd2 = '30'
  } else {
    timeEnd1 = Number(timeStr1) + 1
    timeEnd2 = '00'
  }
  let time2 = timeEnd1 + ':' + timeEnd2
  let retTime = time + '-' + time2
  return retTime
}
// export const timeFilter2 = (time) => {
//   let dateStart0 = time.substr(0, 10)
//   let timeSub = time.substr(11)
//   let timeEnd2 = timeFilter(timeSub) + ':00'
//   return (time + '-' + dateStart0 + ' ' + timeEnd2)
// }
// 正则表达式
export const regs = {
  email: '^([0-9A-Za-z\\-_\\.]+)@([0-9a-z]+\\.[a-z]{2,3}(\\.[a-z]{2})?)$',
  postalCode: '^[1-9][0-9]{5}$',
  telPhone: '^1[0-9]{10}$',
  otpCode: '^[0-9]{4+}$',
  name: '.{1,}',
  pwd: '^(?=.*[a-zA-Z])(?=.*\\d)[a-zA-Z\\d\\!\\@\\#\\$\\%\\&\\-\\_\\.\\]\\*\\$]{8,40}$',
  address: '^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$'
}
export const getCode = () => {
  let urlRaw = api.reservation.vallicode()
  let src = urlRaw + '?stamp=' + Date.now()
  return src
}

export const sortFunc = (array1) => {
  let array2 = array1
  array2.sort((a, b) => {
    let date1 = new Date(a.customerReserveDate0).valueOf()
    let date2 = new Date(b.customerReserveDate0).valueOf()
    return Number(date1) - Number(date2)
  })
  return array2
}

export const isMobileDevice = () => {
  console.log('check is mobile device')
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile/i.test(navigator.userAgent)
}
export const Condition = () => {
  let url = location.href
  let conditionFlag = null
  if (url.indexOf('pet-service') === -1) {
    conditionFlag = false
  } else {
    conditionFlag = true
  }
  return conditionFlag
}
